import React from 'react'
import { selectFirstAddress, selectIsEligibleFor360 } from '../../store/address/address.selectors'
import { usePano } from '../outdoor/Utils'
import { withEmptyFallbackErrorBoundary } from '../error/EmptyFallbackErrorBoundary'
import { useSelector } from 'react-redux'
import { TAG_ADDRESS_IMMERSIVE } from '../analytics/analytics.tagids.constants'
import PanoPreview from '../outdoor/PanoPreview'
import s from './AddressPanoPreview.less'

const useAddressPano = () => {
  const address = useSelector(selectFirstAddress)
  const enabled = useSelector(selectIsEligibleFor360)
  const { lat, lng } = address.coordinates ?? {}

  return usePano({
    lat,
    lng,
    enabled,
    preview: false
  })
}

function AddressPanoPreview() {
  const panoData = useAddressPano()

  if (!panoData.url) return <></>

  return (
    <div className={s.root}>
      <PanoPreview panoData={panoData} tagId={TAG_ADDRESS_IMMERSIVE} />
    </div>
  )
}

export default withEmptyFallbackErrorBoundary(AddressPanoPreview)
